import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Logo from '../../components/Logo'
import classNames from 'classnames'
import PartnerLanguageSwitcher from './PartnerLanguageSwitcher'

const PartnerHeader = (props) => {
  return (
    <div
      className={classNames([
        'text-white',
        'flex',
        'justify-center',
        'py-24',
        'px-16',
        'items-center',
        { 'absolute z-10 w-full': props.transparent },
      ])}
    >
      <div className="mr-auto grow">
        <PartnerLanguageSwitcher
          onLanguageChange={props.onLanguageChange}
          languages={props.languages || undefined}
        />
      </div>
      <Logo inverted={true} />
      {props.partnerLogo && (
        <Fragment>
          <span className="xl:px-50 px-20 type-24-demibold md:px-30 lg:px-40">
            +
          </span>
          <div>{props.partnerLogo}</div>
        </Fragment>
      )}
      <div className="grow" />
    </div>
  )
}

PartnerHeader.propTypes = {
  partner: PropTypes.string,
  transparent: PropTypes.bool,
  partnerLogo: PropTypes.node,
  onLanguageChange: PropTypes.func,
  languages: PropTypes.arrayOf(PropTypes.string),
}

export default PartnerHeader
